/* Predictive prefetch — warms the next page's HTML on hover / keyboard focus / press
   so navigation feels instant. Deliberately conservative:
     - same-origin document links only
     - honors Save-Data, prefers-reduced-data, and slow (2g) connections
     - dedupes, caps total prefetches, and skips cart / checkout / account / auth /
       external / download / new-tab / non-http links and the current page
   Toggled by the theme's "Speed" setting (on by default). */
(function () {
  'use strict';
  if (!document.head || !('addEventListener' in document)) return;

  /* respect the visitor's data preferences + slow links */
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
  try { if (window.matchMedia('(prefers-reduced-data: reduce)').matches) return; } catch (e) {}

  /* only if the browser actually supports <link rel=prefetch> */
  var probe = document.createElement('link');
  if (!(probe.relList && probe.relList.supports && probe.relList.supports('prefetch'))) return;

  var origin = location.origin;
  var here = location.href.split('#')[0];
  var seen = Object.create(null);
  var count = 0;
  var MAX = 60;
  var SKIP = /\/(cart|checkout|account|challenge|orders|logout|login|register|password|admin|apps)(\/|$|\?|#)/;
  var timer = null;

  /* returns the prefetchable URL, or false */
  function eligible(a) {
    if (!a || a.tagName !== 'A' || !a.href) return false;
    if (a.origin !== origin) return false;
    if (a.protocol !== 'http:' && a.protocol !== 'https:') return false;
    if (a.hasAttribute('download')) return false;
    if (a.target && a.target !== '_self') return false;
    var rel = (a.rel || '').toLowerCase();
    if (rel.indexOf('nofollow') > -1 || rel.indexOf('external') > -1) return false;
    if (SKIP.test(a.pathname + a.search)) return false;
    var url = a.href.split('#')[0];
    if (url === here || seen[url]) return false;
    return url;
  }

  function prefetch(url) {
    if (seen[url] || count >= MAX) return;
    seen[url] = 1;
    count++;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  }

  function closestLink(t) { return t && t.closest ? t.closest('a') : null; }

  /* hover / focus = intent — wait a beat so a passing cursor doesn't fire */
  function intent(e) {
    var url = eligible(closestLink(e.target));
    if (!url) return;
    clearTimeout(timer);
    timer = setTimeout(function () { prefetch(url); }, 65);
  }
  /* press = high intent — fetch immediately */
  function press(e) {
    var url = eligible(closestLink(e.target));
    if (url) prefetch(url);
  }
  function cancel() { clearTimeout(timer); }

  var opt = { passive: true, capture: true };
  document.addEventListener('mouseover', intent, opt);
  document.addEventListener('focusin', intent, opt);
  document.addEventListener('mouseout', cancel, opt);
  document.addEventListener('mousedown', press, opt);
  document.addEventListener('touchstart', press, opt);
})();
